import { useMutation, useQueryClient } from 'react-query';
import { toast } from 'react-hot-toast';

import { Guid } from '@project/types';
import adminFinesService from '@project/services/api/admin-fines/admin-fines.service';

export const useMoveFinesToUnPaidFromProfile = () => {
  const queryClient = useQueryClient();
  return useMutation<void, string[], Guid[]>(
    (checkedFines) => adminFinesService.moveFinesToUnPaidFromProfile(checkedFines),
    {
      onError: () => {
        toast.error('Error Moving Fines To Unpaid fine.');
      },
      onSuccess: () => {
        queryClient.invalidateQueries(['paged-profile-fines']);
      },
    },
  );
};
